/* ancona-v5-editorial.js — ANCONA APEX V5 editorial route module.
   Emitted from layout/theme.liquid for non-home/discovery/product/cart routes
   (1 route JS request). One real behavior: optional product context on the
   Contact (Private Client Studio) form.
   A visitor arriving from a product page or the Client Book ("Ask about this
   list") may carry validated PUBLIC product handles in the URL:
     /pages/contact?products=handle-one,handle-two
   This module validates each handle, resolves the live product identity and
   title from the public /products/{handle}.js endpoint, omits anything the
   presentation policy cannot verify, renders accepted product links, and
   fills a native contact[...] field with the public product URLs so they reach
   the store's contact email. No personal data, price, or availability is read
   from or written to the URL. Without the parameter the block stays hidden and
   the form is unchanged. Progressive enhancement only — the native Shopify
   contact form works fully without this file. */
(function () {
  'use strict';
  if (window.__anconaV5Editorial) return;
  window.__anconaV5Editorial = true;

  var MAX_HANDLES = 8;
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function rootUrl(p) { return root.replace(/\/$/, '') + '/' + String(p).replace(/^\//, ''); }

  function readHandles() {
    var out = [];
    try {
      var raw = new URLSearchParams(window.location.search).get('products') || '';
      raw.split(',').forEach(function (part) {
        var h = part.trim().toLowerCase();
        if (HANDLE_RE.test(h) && out.indexOf(h) === -1 && out.length < MAX_HANDLES) out.push(h);
      });
    } catch (e) { return []; }
    return out;
  }

  function fetchProduct(handle) {
    return fetch(rootUrl('/products/' + handle + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var policy = window.AnconaV5 && window.AnconaV5.presentationPolicy;
        if (!product || !policy || !policy.allows(product.id)) return null;
        return typeof product.title === 'string' && product.title ? product : null;
      })
      ['catch'](function () { return null; });
  }

  function populate(element, handles) {
    var list = element.querySelector('[data-av5-context-list]');
    var field = element.querySelector('[data-av5-context-field]');
    if (!list || !handles.length) return;
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var accepted = products
        .map(function (product, index) { return product ? { product: product, handle: handles[index] } : null; })
        .filter(Boolean);
      if (!accepted.length) return;
      var urls = accepted.map(function (entry) {
        return window.location.origin + rootUrl('/products/' + entry.handle);
      });
      if (field) field.value = urls.join(' ');
      list.textContent = '';
      accepted.forEach(function (entry) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = rootUrl('/products/' + entry.handle);
        a.textContent = entry.product.title;
        li.appendChild(a);
        list.appendChild(li);
      });
      element.hidden = false;
    });
  }

  function init(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    target.querySelectorAll('[data-av5-contact-context]').forEach(function (element) {
      if (element.dataset.initialized === 'true') return;
      element.dataset.initialized = 'true';
      var handles = readHandles();
      if (handles.length) populate(element, handles);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
